@if (isInitialized) {
  <app-topheader></app-topheader>
}
@if (isInitialized) {
  <div class="row app-header">
    <div class="col-1">
      <app-sidebar></app-sidebar>
    </div>
    <div class="col-11 minheight">
      <router-outlet></router-outlet>
    </div>
  </div>
}
<ngx-spinner name="upsSpinner" bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#321815" type="custom" [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>